import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  liveRespirationData: [],
  pushDataToGraph: {},
  graphLoading: false,
  liveRscore: {},
}

export default factoryReducer(initialState, actions)
